/* eslint-disable*/
import { withStyles } from '@material-ui/core';

import _capitalize from 'lodash/capitalize';
import _debounce from 'lodash/debounce';
import _every from 'lodash/every';
import _get from 'lodash/get';
import _groupBy from 'lodash/groupBy';
import _join from 'lodash/join';

import PropTypes from 'prop-types';
import React, { Component } from 'react';

import combineStyles from '../../../../helpers/combineStyles';
import TypographyStyles from '../../../../styles/typography';
import ButtonStyles from '../../../../styles/button';

import CustomDialog from '../../../shared/Modals/CustomDialog';

import BulkLoad from '../../../shared/BulkLoad/BulkLoad';

class SaleReturnCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: ''
    };
  }

  _handleSave = () => {
    this.props
      .returnArticlesSalesMassive({ file: this.state.file })
      .then(r => {
        this.file = '';

        if (r.success) {
          this._handleClose();
        }
      });
  };

  _handleClose = () => {
    const { requestSend } = this.props;
    if (!requestSend) this.props.onClose();
  };

  handleChangeFile = file =>  this.setState({ file });

  _disableSubmit = () => {
    return !this.state.file;
  };

  render() {
    const {
      classes,
      requestSend,
      requestSendMassive,
      canReturnArticlesSalesMassive,
      requestReturnArticlesSalesMassiveSend
    } = this.props;

    return (
      <div>
        <CustomDialog
          open={true}
          loading={requestSend || requestSendMassive || requestReturnArticlesSalesMassiveSend}
          disabled={
            this._disableSubmit() ||
            requestSend ||
            requestSendMassive
          }
          disableBackdropClick={true}
          headerSecondary={<div />}
          onClose={this._handleClose}
          onConfirm={() => this._handleSave(false)}
          title={'Devolución masiva cardif'}
          buttonText={'Guardar'}
          classes={{
            root: classes.dialogRoot
          }}
        >
          {canReturnArticlesSalesMassive && (
            <BulkLoad
              templatePath={'/docs/plantilla-devolucion-masiva-cardif.xlsx'}
              handleChangeFile={this.handleChangeFile}
            />
          )}
        </CustomDialog>
      </div>
    );
  }
}

const styles = theme => ({
  dialogRoot: {
    width: 800
  }
});

SaleReturnCreate.propTypes = {
  open: PropTypes.bool
};

export default withStyles(
  combineStyles(styles, TypographyStyles, ButtonStyles),
  {
    withTheme: true
  }
)(SaleReturnCreate);
